import React, { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import APP_ROUTES from "src/routes/routes";
import LoadingWrapper from "src/components/Common/Table/Loading";
import useGetInstanceDetail from "src/components/ProjectInstance/detail/useGetInstanceDetail";
import InstanceDetailForm from "src/components/ProjectInstance/form/InstanceDetailForm";
import routeGuard from "src/Hooks/routeGuard";
import { PAGINATION_DEFAULT, RESOURCE_TYPE } from "src/constant/common";
import useEditInstanceDetail from "src/components/ProjectInstance/detail/useEditInstanceDetail";
import useGetInstanceUploadFileHistories from "src/components/ProjectInstance/detail/useGetInstanceUploadFileHistories";

export const FORM_NAME = {
  MAIN: {
    ID: "id",
    INCREMENT_ID: "increment_id",
    LINKED_ID: "linked_instance_id",
    STATUS: "status",
    NAME: "name",
    DESCRIPTION: "description",
    LAST_DEPLOY: "gg_deployment_created_at",
    UPDATED_AT: "updated_at",
    DASHBOARD_OPI: "opi_s3_key",
    MDB: "mdb_s3_key",
    OPI_UPDATE: "opi_update_at",
    MDB_UPDATE: "mdb_update_at",
    MDB_SOURCE: "mdb_source",
    OPI_SOURCE: "opi_source",
    HOST: "hostname",
    PORT: "port",
    OWNER: "created_by_name",
  },
  FILES: {
    DASHBOARD_OPI: "opi_s3_key",
    MDB: "mdb_s3_key",
    UPDATED_AT: "updated_at",
    MDB_UPDATE: "mdb_update_at",
    OPI_UPDATE: "opi_update_at",
    FILE_TYPE: "file_type",
    FILE_NAME: "s3_key",
    SOURCE: "source",
    CHANGED_BY: "updated_by_name",
    DEPLOYED_FOR_TEST: "test_package_input_id",
  },
  ACCESS_SETTING: {},
};

const InstanceDetail = () => {
  const { id } = useParams();
  let [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const filesHistoryPage = searchParams.get("filesHistoryPage");
  const condition = searchParams.get("condition");

  const getRedirectURL = useCallback(() => {
    if (condition) {
      return `${APP_ROUTES.PROJECT_INSTANCE}?id=${id}${page ? "&page=" + page : ""}${condition ? "&condition=" + condition : ""}`;
    }
    return `${APP_ROUTES.PROJECT_INSTANCE}?id=${id}${page ? "&page=" + page : ""}`;
  }, [id, page, condition]);

  const { data: instanceDetail, isLoading: isLoadingInstanceDetail } = useGetInstanceDetail(id);
  const { data: fileHistories, isFetching: isFetchingFileHistories } = useGetInstanceUploadFileHistories(id, {
    filesHistoryPage,
    limit: PAGINATION_DEFAULT.smallPageSize,
  });
  const { submitData } = useEditInstanceDetail(getRedirectURL);

  return (
    <LoadingWrapper loading={isLoadingInstanceDetail} customClass="loading-detail-page">
      <InstanceDetailForm
        submitData={submitData}
        instanceData={instanceDetail}
        fileHistories={fileHistories}
        isFetchingFileHistories={isFetchingFileHistories}
        getRedirectURL={getRedirectURL}
      />
    </LoadingWrapper>
  );
};

export default routeGuard(InstanceDetail, RESOURCE_TYPE.PROJECT_INSTANCE);
